<template>
  <li>
    <router-link :to="slug" class="c-footer__link">{{ name }}</router-link>
  </li>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    page: String,
  },
  computed: mapState({
    name(state) {
      return state.groups[this.page].name;
    },
    slug(state) {
      return `/${state.groups[this.page].slug}`;
    },
  }),
};
</script>
